/* eslint-disable max-len */
import React, { useState ,useContext} from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import moment from 'moment'
import { handleSidebarAnimation } from '../../../../redux/commonSlice'
import AnimatedList from '../../../../components/Animation/AnimatedList'
import { convertToPatientTimeZoneDateFormat } from '../../../../CommonMethods/ConvertDatetoPatientTimezone'
import { resetDashboardSearch } from '../../../../redux/dashboardSearchSlice'
import GlobalContext from '../../../../components/Context/GloablContext'

const TableBody = ({ tableData,
    indexNum,
}) => {
    const navigate = useNavigate()
    const auth = useSelector(state => state?.auth)
    const dispatch = useDispatch()
    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)
    const selectedRows = useSelector(state => state?.MultiSelectSliceConditionally?.selectedRows?.selectedIds)
    const [searchParams,setSearchParams]=useSearchParams({})
    const {setIsSearchOpen} = useContext(GlobalContext);

    
    
    const date=convertToPatientTimeZoneDateFormat(tableData?.measurement_date_time,dateformat,tableData?.timezone)

    const formattedVitalType = tableData?.reading_type?.replace(/_/g, ' ')?.replace(/\b\w/g, (char) => char.toUpperCase());

    return (
        <>
            <AnimatedList
                id={tableData?.device_id}
                rowStatus={tableData?.status}
                keyItem={indexNum}
                cursorpointer
                handleClick={(e)=>{
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        setIsSearchOpen(false)
                        dispatch(resetDashboardSearch());
                        navigate(`/manage-dashboard/provider-list/${tableData.patient_object_id}/${tableData.patient_id}`,{state:{"limit":searchParams.get("limit"),"page_number":searchParams.get("page_number"),'user_id':tableData?.patient_id,'id':tableData?._id}})
                    }
                }}
                child={
                    <>
                        <td className="px-[18px] py-2 text-sm text-start prevent-click  font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            {date}
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{formattedVitalType==='Spo2' ? "SPO2" : formattedVitalType}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.alert_type}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            <span className={`${tableData?.reading_details?.includes('/') ? "flex" : ""}`}>
                                {tableData?.reading_details?.split('/').map((detail, index, array) => (
                                    <span key={index}>
                                        <span 
                                            className={`${detail === 'Too Low' ? "bg-[#F9E8E9] text-[#D3454D]" : 
                                                detail === 'Too High' ? 'bg-[#EEB9BC] text-[#C81720]' : 
                                                    detail === 'Nominal' ? 'bg-[#9BD6AD] text-[#1A883C]' : 
                                                        (detail === 'Missed Reading' || detail === 'Data Error') ? 'bg-[#E7EAF4] text-[#000000]' : "" } 
                                                        rounded-[28px] px-2 py-1`}
                                        >
                                            {detail}
                                        </span>
                                        {index < array.length - 1 && <span className="mx-1">/</span>}
                                    </span>
                                ))}
                            </span>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.last_name} {tableData?.first_name} {tableData?.middle_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.vital_reading_count=== "" || tableData?.vital_reading_count===undefined) ? "-" :tableData?.vital_reading_count} / {(tableData?.vital_total_count=== "" || tableData?.vital_total_count===undefined) ? "-" :tableData?.vital_total_count}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.wellness_reading_count=== "" || tableData?.wellness_reading_count===undefined) ? "-" :tableData?.wellness_reading_count} / {(tableData?.wellness_total_count=== "" || tableData?.wellness_total_count===undefined) ? "-" :tableData?.wellness_total_count}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{(tableData?.wellness_pending_days=== "" || tableData?.wellness_pending_days===undefined) ? "-" :tableData?.wellness_pending_days}</td>
                        <td className="px-[18px] py-2 text-start text-sm  font-normal text-[#031624]">{(tableData?.vital_pending_days=== "" || tableData?.vital_pending_days===undefined) ? "-" :tableData?.vital_pending_days}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.device_id}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.user_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.patient_id}</td>
                        <td className={`px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px] sticky right-[-1px] prevent-click ${selectedRows.some(item => item.id === tableData.device_id) ? 'bg-[#F8EEF1]' : 'bg-white '} last-td`}>
                            <button
                                id='view'
                                data-testId={`view-btn-${indexNum}`}
                                className='border border-[#972E4C] rounded-md text-[#972E4C] text-[15px] py-1.5 px-4 leading-[12px]'>
                                View
                            </button>
                        </td>
                    </>

                } />
        </>
    )
}

export default TableBody